require('./retailLoanCarouselSection.scss');
//@vendor
const React = require('react');
const PropTypes = require('prop-types');
//@commons
const { OKButton } = require('components/commons/OKButton/OKButton');
//@utilities
const { getFormattedString, decimalsLength } = require('utilities/currencyHelper');
const {
    PROC_RETAIL_LOAN,
    EVENT_BUY,
    recordLink
} = require('utilities/tagging');
//@constants
const { ENABLE_RETAIL_LOAN_HIRE_IN_CC } = require('constants/contactCenter/retailLoanConstants');
const placeHolder = require('../../../../assets/images/placeHolder.png');

class RetailLoanCarouselSection extends React.Component {

    constructor(props) {
        super(props);
        this.handleClickBuyButton = this.handleClickBuyButton.bind(this);
    }

    handleClickBuyButton(item) {
        const { setItemProduct, handleProductsClick } = this.props;

        if (setItemProduct) {
            if (handleProductsClick) handleProductsClick(item);
            setItemProduct(item.get('nid'), item.get('deliveryDate'));
            recordLink(PROC_RETAIL_LOAN, EVENT_BUY, item.get('title'));
        }
    }

    render() {
        const { item, labels } = this.props;
        const minimumQuota = getFormattedString({
            amount: item.get('field_value_minimum_quota'),
            currency: labels.euroSymbol,
            decimalsLength: decimalsLength(item.get('field_value_minimum_quota'))
        });
        const labelDelivery = minimumQuota + " " + labels.subtitleDateEstimatedDelivery2;
        const showBuyButton = !__CONTACT_CENTER__ || ENABLE_RETAIL_LOAN_HIRE_IN_CC;

        return (
            <div>
                <div className="retail-loan-carousel-section__container-image">
                    <img
                        className="retail-loan-carousel-section__image"
                        src={item.get('field_product_images').first().get('url')}
                        onError={(e) => { e.target.src = placeHolder; }}
                    />
                </div>
                <div className="retail-loan-carousel-section__title-product">
                    {item.get('title')}
                </div>
                <div className="retail-loan-carousel-section__subtitle-product">
                    {labelDelivery}
                </div>
                <div className="retail-loan-carousel-section__container-button">
                    {showBuyButton && <OKButton
                        modifier="ghost"
                        onClick={() => this.handleClickBuyButton(item)}
                    >
                        {item.get('field_buy_button')}
                    </OKButton>}
                </div>
            </div>
        );
    }

}

RetailLoanCarouselSection.propTypes = {
    item: PropTypes.object.isRequired,
    labels: PropTypes.object.isRequired,
    setItemProduct: PropTypes.func,
    handleProductsClick: PropTypes.func,
}

export { RetailLoanCarouselSection };
